var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        lazy: "",
        "full-width": !_vm.$vuetify.breakpoint.smAndDown,
        "max-width": "500"
      },
      on: {
        input: function(v) {
          return v
        }
      },
      model: {
        value: _vm.openDialog,
        callback: function($$v) {
          _vm.openDialog = $$v
        },
        expression: "openDialog"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "pa-4" },
        [
          _c(
            "v-toolbar",
            [
              _c(
                "v-toolbar-side-icon",
                [
                  _c("v-icon", { attrs: { color: "accent" } }, [
                    _vm._v("headset_mic")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { column: "" } },
                [
                  _vm.outsideTrucks
                    ? _c("v-toolbar-title", [_vm._v("Record Phone Dispatch")])
                    : _c("v-toolbar-title", [
                        _vm._v(
                          "Assign to " +
                            _vm._s(_vm.loadGroupOwnerName(_vm.load))
                        )
                      ]),
                  _vm._v(" "),
                  _c("v-list-tile-sub-title", { staticClass: "font-italic" }, [
                    _vm._v(
                      "\n          Assignable loads: " +
                        _vm._s(
                          _vm.planningLoadGroupAvailableTruckCount(_vm.load)
                        ) +
                        "\n        "
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { column: "", "pt-3": "" } },
            [
              _c("span", { staticClass: "title mb-2" }, [_vm._v("Trucks")]),
              _vm._v(" "),
              _c("v-select", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value:
                      "required|min_value:1|max_value:" +
                      _vm.planningLoadGroupAvailableTruckCount(_vm.load),
                    expression:
                      "`required|min_value:1|max_value:${planningLoadGroupAvailableTruckCount(load)}`"
                  }
                ],
                attrs: {
                  items: _vm.planningLoadGroupAvailableLoadAssignmentRangeOptions(
                    _vm.load
                  ),
                  "error-messages": _vm.errors.first("assignedLoads", "modal"),
                  "data-vv-as": "Assigned Truck Count",
                  "data-vv-name": "planningLoad.__assignTruckCount",
                  "data-vv-scope": "modal",
                  label: "Assigned Truck Count"
                },
                on: {
                  change: function($event) {
                    $event > 1 ? (_vm.assignTruckDriverUserId = null) : 1
                  }
                },
                model: {
                  value: _vm.assignTruckCount,
                  callback: function($$v) {
                    _vm.assignTruckCount = _vm._n($$v)
                  },
                  expression: "assignTruckCount"
                }
              }),
              _vm._v(" "),
              _vm.outsideTrucks
                ? [
                    _c(
                      "v-subheader",
                      {
                        staticClass: "pl-0",
                        attrs: {
                          disabled: !_vm.canAssignDriverToDirectDispatchLoads
                        }
                      },
                      [
                        _vm._v(
                          "\n          Notify the office of the outside truck assignment:\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-list",
                      { attrs: { "two-line": "" } },
                      [
                        _c(
                          "v-list-tile",
                          [
                            _c(
                              "v-list-tile-action",
                              [
                                _c("v-icon", { attrs: { color: "primary" } }, [
                                  _vm._v("headset_mic")
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("v-autocomplete", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate.immediate",
                                  value: { required: true },
                                  expression: "{ required: true }",
                                  modifiers: { immediate: true }
                                }
                              ],
                              staticClass: "mt-0",
                              attrs: {
                                clearable: "",
                                label: "Contact Dispatcher",
                                loading: false,
                                value: _vm.value,
                                disabled: false,
                                items: _vm.company.dispatchContacts || [],
                                "search-input": _vm.search,
                                "error-messages": _vm.errors.first(
                                  "dispatchContactId",
                                  "modal"
                                ),
                                "data-vv-as": "Dispatch Contact",
                                "data-vv-name": "dispatchContactId",
                                "data-vv-scope": "modal",
                                "item-text": "name",
                                "return-object": ""
                              },
                              on: {
                                "update:searchInput": function($event) {
                                  _vm.search = $event
                                },
                                "update:search-input": function($event) {
                                  _vm.search = $event
                                }
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "item",
                                    fn: function(data) {
                                      return [
                                        _c(
                                          "v-layout",
                                          { attrs: { column: "" } },
                                          [
                                            _c("v-list-tile-title", [
                                              _vm._v(_vm._s(data.item.name))
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "v-list-tile-sub-title",
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass: "pl-1 pr-2",
                                                    attrs: { small: "" }
                                                  },
                                                  [_vm._v("phonelink_ring")]
                                                ),
                                                _vm._v(
                                                  _vm._s(data.item.phone) +
                                                    "\n                  "
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2998099087
                              ),
                              model: {
                                value: _vm.assignedDispatchContact,
                                callback: function($$v) {
                                  _vm.assignedDispatchContact = $$v
                                },
                                expression: "assignedDispatchContact"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-list-tile",
                          [
                            _c(
                              "v-list-tile-content",
                              { staticClass: "checkbox-content" },
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { row: "" } },
                                  [
                                    !_vm.outsideTrucksPercentage
                                      ? _c("v-icon", [_vm._v("attach_money")])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("v-text-field", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate.immediate",
                                          value: { required: true },
                                          expression: "{ required: true }",
                                          modifiers: { immediate: true }
                                        }
                                      ],
                                      class: { "pb-2": _vm.errors.any() },
                                      attrs: {
                                        label: "Offer Rate",
                                        "error-messages": _vm.errors.first(
                                          "offerRate",
                                          "modal"
                                        ),
                                        "data-vv-as": "Load Offer Rate",
                                        "data-vv-name": "offerRate",
                                        "data-vv-scope": "modal"
                                      },
                                      model: {
                                        value: _vm.outsideTrucksRate,
                                        callback: function($$v) {
                                          _vm.outsideTrucksRate = $$v
                                        },
                                        expression: "outsideTrucksRate"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _vm.outsideTrucksPercentage
                                      ? _c("v-icon", [_vm._v("percent")])
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-tile-action",
                              [
                                _c("v-checkbox", {
                                  attrs: { label: "as a percentage" },
                                  model: {
                                    value: _vm.outsideTrucksPercentage,
                                    callback: function($$v) {
                                      _vm.outsideTrucksPercentage = $$v
                                    },
                                    expression: "outsideTrucksPercentage"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("v-text-field", {
                      attrs: { label: "Notes" },
                      model: {
                        value: _vm.outsideTrucksNote,
                        callback: function($$v) {
                          _vm.outsideTrucksNote = $$v
                        },
                        expression: "outsideTrucksNote"
                      }
                    })
                  ]
                : [
                    _c(
                      "v-subheader",
                      {
                        staticClass: "pl-0",
                        attrs: {
                          disabled: !_vm.canAssignDriverToDirectDispatchLoads
                        }
                      },
                      [
                        _vm._v(
                          "\n          Optionally, direct dispatch a driver:\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("v-select-driver", {
                      attrs: {
                        company: _vm.company,
                        disabled: !_vm.canAssignDriverToDirectDispatchLoads,
                        value: _vm.assignTruckDriverUserId
                      },
                      on: {
                        change: function($event) {
                          return _vm.selectDriverChange($event)
                        }
                      }
                    })
                  ],
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "accent",
                        loading: _vm.loadingBtn,
                        disabled: _vm.errors.any("modal")
                      },
                      on: {
                        click: function($event) {
                          return _vm.assignTrucks()
                        }
                      }
                    },
                    [_vm._v("\n          Assign\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "accent", flat: "" },
                      on: {
                        click: function($event) {
                          _vm.openDialog = false
                        }
                      }
                    },
                    [_vm._v("\n          Cancel\n        ")]
                  )
                ],
                1
              )
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33497c1f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33497c1f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/AssignTruckDialog.vue
// module id = null
// module chunks = 